import Api from './Api';

export default {
    create: function (credentials) {
        var url = '/address/add';  
        
        var form = new FormData(); 
        
        form.append('api_token', credentials.api_token || null);
        form.append('version', 2);

        form.append('address', credentials.address);
        form.append('postal_code', credentials.postal_code);
        form.append('city', credentials.city);
        form.append('country', credentials.country);
        form.append('extra_infos', credentials.extra_infos ); 

        return Api().post(url, form);
    },
    readAll: function (credentials) {
        var url = '/address/get';  
        let form = {
            params: {
                // kta_id : credentials.kta_id || '',
                version: 2,
                api_token : credentials.api_token || null ,
                timestamp: Math.random()
            }
        }
        return Api().get(url, form); 
    },
    update: function (credentials) {
        var url = '/address/update';  
        var form = new FormData(); 
        
        form.append('api_token', credentials.api_token || null);
        form.append('version', 2); 

        form.append('id', credentials.id);
        form.append('address', credentials.address);
        form.append('postal_code', credentials.postal_code);
        form.append('city', credentials.city);
        form.append('country', credentials.country);
        form.append('extra_infos', credentials.extra_infos ); 

        return Api().post(url, form);
    },
    delete : function (credentials) {
        var url = '/address/delete';  
        var form = new FormData(); 
        form.append('api_token', credentials.api_token || null);
        form.append('version', 2);
        form.append('id', credentials.id || null);
        return Api().post(url, form);
    }, 
  
};
